import { Link } from '@tanstack/react-router'
import { PageHeader } from '../components/PageHeader'
import { useLocale } from '../i18n'

export function NotFoundScreen() {
  const { messages } = useLocale()
  return (
    <PageHeader
      title={messages.app.notFound}
      intro={
        <Link to="/" className="touch-target">
          {messages.app.home}
        </Link>
      }
    />
  )
}
